import styled, { css } from 'styled-components';

export const FullBar = styled.div`
  height: 4px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
`;
export const ProgressBar = styled.div<{
  percentComplete: number;
}>`
  ${({ percentComplete }) =>
    css`
      width: ${percentComplete}%;
    `}

  height: 4px;
  background: #000000;
  border-radius: 0px 32px 32px 0px;
`;
